import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Avatar, Button, Stack } from "@mui/material";
import Box from "@mui/material/Box";
import React from "react";
import "./Header.css";
import { useHistory, Link } from "react-router-dom";

const Header = ({ children, hasHiddenAuthButtons }) => {
  const history = useHistory();
  const isLoggedIn = localStorage.getItem('token');
  const userName = localStorage.getItem('username');

  const handleLogout = () => {
    localStorage.clear();
    window.location.reload();
  };


  if(!hasHiddenAuthButtons){
    return (
      <Box className="header">
        <Box className="header-title">
          <img src="logo_light.svg" alt="QKart-icon" />
        </Box>
  
        {children}

        <Stack direction="row" spacing={1} alignItems="center">
          {isLoggedIn ? (
            <>
              <Avatar src="/avtar.png" alt={userName} />
              <p>{userName}</p>
              <Button onClick={handleLogout}>Logout</Button>
            </>
          ) : (
            <>
              <Button
                onClick={() => {
                  history.push('/login');
                }}
              >
                Login
              </Button>
  
              <Button
                variant="contained"
                onClick={() => {
                  history.push('/register');
                }}
              >
                Register
              </Button>
            </>
          )}
        </Stack>
      </Box>
    );

  }
  return(
    <Box className="header">
      <Box className="header-title">
        <img src="logo_light.svg" alt="QKart-icon"></img>
      </Box>
      <Button
      className="explore-button"
      startIcon={<ArrowBackIcon/>}
      variant="text"
                onClick={() => {
                  history.push('/');
                }}
              >
               Back to Explore
              </Button>
    </Box>
  )

  
};

export default Header;
